export const RECEIPT_COMPELLING_EVIDENCE_SLICE_NAME = "receiptCompellingEvidence"
